import { render } from "./CIcon.vue?vue&type=template&id=dd129184"
import script from "./CIcon.vue?vue&type=script&lang=js"
export * from "./CIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__